<template>
    <div class="form-group has-effect date-range">
        <input
            :placeholder="placeholder"
            :name="name"
            :id="id"
            class="form-control date-input-range"
            data-notes-range
            autocomplete="off"
        />
        <a-icon
            v-if="clear"
            style="width: 16px; height: 16px"
            @click.native="$emit('change', null)"
            class="form-group-close"
            icon="Close"
        />
    </div>
</template>

<script>
import moment from 'moment'
import Litepicker from 'litepicker'

export default {
    data() {
        return {
            clear: false,
            elem: null
        }
    },
    props: {
        placeholder: {
            type: String,
            required: false
        },
        id: {
            type: String,
            required: false
        },
        name: {
            type: String,
            required: false
        },
        val: {
            type: String,
            require: false
        },
        lockFutureDays: {
            type: Array,
            require: false
        },
        lockPastDays: {
            type: Array,
            require: false
        },
        lockRangeDaysNumber: {
            type: Number,
            require: false
        }
    },
    mounted() {
        /* eslint-disable no-unused-vars */
        const context = this
        const settings = {
            lang: 'pl-PL',
            format: 'DD-MM-YYYY',
            showTooltip: false
        }

        const notesRange = document.querySelector(`#${this.id}`)
        if (notesRange) {
            const notesRangePicker = new Litepicker({
                element: notesRange,
                numberOfMonths: 2,
                numberOfColumns: 2,
                singleMode: false,
                lockDaysFormat: 'DD-MM-YYYY',
                maxDays: this.lockRangeDaysNumber,
                lockDays: context.setLockDays,
                setup: picker => {
                    picker.on('selected', (date1, date2) => {
                        date1 = moment(date1.dateInstance).format('DD-MM-YYYY')
                        date2 = moment(date2.dateInstance).format('DD-MM-YYYY')
                        const valDates = this.val?.split(',')
                        if (
                            !valDates ||
                            moment(picker.getStartDate()?.dateInstance).format(
                                'YYYY-MM-DD'
                            ) !== valDates[0] ||
                            moment(picker.getEndDate()?.dateInstance).format(
                                'YYYY-MM-DD'
                            ) !== valDates[1]
                        ) {
                            context.$emit(
                                'change',
                                `${moment
                                    .utc(date1, 'DD-MM-YYYY')
                                    .format('YYYY-MM-DD')},${moment
                                    .utc(date2, 'DD-MM-YYYY')
                                    .format('YYYY-MM-DD')}`
                            )
                        }
                        if (date1) {
                            context.clear = true
                        } else {
                            context.clear = false
                        }
                    })
                },
                ...settings
            })
            this.elem = notesRangePicker
            if (this.val) {
                const dates = this.val.split(',')
                notesRangePicker.setDateRange(dates[0], dates[1])
            }
        }
    },
    computed: {
        lockFutureDay() {
            if (!this.lockFutureDays) return
            const validDates = this.lockFutureDays.filter(
                date => date !== '' && typeof date !== 'undefined'
            )
            if (validDates.length === 0) return
            const momentDates = validDates.map(date => moment(date))
            const earliestDate = moment.min(momentDates)
            return earliestDate
        },
        lockPastDay() {
            if (!this.lockPastDays) return
            const validDates = this.lockPastDays.filter(
                date => date !== '' && typeof date !== 'undefined'
            )
            if (validDates.length === 0) return
            const momentDates = validDates.map(date => moment(date))
            const latestDate = moment.max(momentDates)
            return latestDate
        },
        setLockFutureDays() {
            return [
                moment(this.lockFutureDay).add(1, 'days'),
                moment(this.lockFutureDay).add(100, 'years')
            ]
        },
        setLockPastDays() {
            return [
                moment(this.lockPastDay).subtract(100, 'years'),
                moment(this.lockPastDay).subtract(1, 'days')
            ]
        },
        setLockDays() {
            const lockDays = []
            if (this.lockFutureDay) {
                lockDays.push(this.setLockFutureDays)
            }
            if (this.lockPastDay) {
                lockDays.push(this.setLockPastDays)
            }
            return lockDays
        }
    },
    watch: {
        lockFutureDay() {
            this.elem.setLockDays(this.setLockDays)
        },
        lockPastDay() {
            this.elem.setLockDays(this.setLockDays)
        }
    }
}
</script>
